import { decodeHtmlEntities } from './product_utilities';

const text_replace_delimeter = '[[REPLACE TEXT]]';
const TranslationsObject = {
	AddToCart: {
		EN: 'Add to Cart',
		FR: 'Ajouter au panier',
		DE: 'In den Warenkorb',
		IT: 'Aggiungi al carrello',
		ES: 'Añadir al carrito',
	},
	AtoZ: {
		EN: 'A to Z',
		FR: 'De A à Z',
		DE: 'Von A bis Z',
		IT: 'Dalla A alla Z',
		ES: 'De la A a la Z',
	},
	AvailableIn: {
		EN: 'Available In',
		FR: 'Disponible en',
		DE: 'Verfügbar in',
		IT: 'Disponibile in',
		ES: 'Disponible en',
	},
	AvailableSingle: {
		EN: 'Low Stock - There is only 1 left.',
		FR: "Stock limité - Il n'en reste plus que 1.",
		DE: 'Geringer Lagerbestand - Nur noch 1 Stück verfügbar.',
		IT: 'Stock limitato - Ne sono rimasti solo 1.',
		ES: 'Stock bajo: solo quedan 1 unidades.',
	},
	AvailableMultiple: {
		EN: 'Low Stock - There are only [[REPLACE TEXT]] left.',
		FR: "Stock limité - Il n'en reste plus que [[REPLACE TEXT]].",
		DE: 'Geringer Lagerbestand - Nur noch [[REPLACE TEXT]] Stück verfügbar.',
		IT: 'Stock limitato - Ne sono rimasti solo [[REPLACE TEXT]].',
		ES: 'Stock bajo: solo quedan [[REPLACE TEXT]] unidades.',
	},
	BackorderDate: {
		EN: 'This item is available for back order. It is expected to be available to ship on [[REPLACE TEXT]].',
		FR: "Cet article est disponible en commande différée. Il devrait être disponible à l'expédition le [[REPLACE TEXT]].",
		DE: 'Dieser Artikel ist nachbestellbar. Die voraussichtliche Lieferzeit ist der [[REPLACE TEXT]].',
		IT: 'Questo articolo è disponibile per ordini in arretrato. La spedizione è prevista per il [[REPLACE TEXT]].',
		ES: 'Este artículo está disponible para pedidos pendientes. Se espera que esté disponible para su envío el [[REPLACE TEXT]].',
	},
	BackorderHasDays: {
		EN: 'This item will be ready to ship in approximately [[REPLACE TEXT]] after you place your order.',
		FR: 'Cet article sera prêt à être expédié vers le [[REPLACE TEXT]] après que vous aurez passé votre commande.',
		DE: 'Dieser Artikel ist nach Ihrer Bestellung vorsaussichtlich am [[REPLACE TEXT]] versandfertig.',
		IT: "Questo articolo sarà pronto per la spedizione intorno al [[REPLACE TEXT]] dopo aver effettuato l'ordine.",
		ES: 'Este artículo estará listo para su envío aproximadamente el [[REPLACE TEXT]] después de que realice su pedido.',
	},
	BestSeller: {
		EN: 'Best Seller',
		FR: 'Meilleures ventes',
		DE: 'Bestseller',
		IT: 'Best Seller',
		ES: 'Más vendido',
	},
	Clearance: {
		EN: 'Clearance',
		FR: 'Dégagement',
		DE: 'Freigabe',
		IT: 'Sgombero',
		ES: 'Despeje',
	},
	Close: {
		EN: 'Close',
		FR: 'Fermer',
		DE: 'Schließen',
		IT: 'Chiudi',
		ES: 'Cerrar',
	},
	Colors: {
		EN: 'Colors',
		FR: 'Couleurs',
		DE: 'Farben',
		IT: 'Colori',
		ES: 'Colores',
	},
	ColorAll: {
		EN: 'Browse All Colors',
		FR: 'Parcourir toutes les couleurs',
		DE: 'Alle Farben durchsuchen',
		IT: 'Sfoglia tutti i colori',
		ES: 'Explorar todos los colores',
	},
	ColorSingle: {
		EN: 'Browse All 1 Color',
		FR: 'Parcourir toutes les couleurs 1',
		DE: 'Alle 1 Farben durchsuchen',
		IT: 'Sfoglia tutti i colori 1',
		ES: 'Ver todos los colores 1',
	},
	ColorMultiple: {
		EN: 'Browse All [[REPLACE TEXT]] Colors',
		FR: 'Parcourir les [[REPLACE TEXT]] couleurs',
		DE: 'Alle [[REPLACE TEXT]] Farben anzeigen',
		IT: 'Sfoglia tutti i [[REPLACE TEXT]] colori',
		ES: 'Ver los [[REPLACE TEXT]] colores',
	},
	ContactUs: {
		EN: 'contact us',
		FR: 'contactez-nous',
		DE: 'kontaktieren Sie uns',
		IT: 'contattaci',
		ES: 'póngase en contacto con nosotros',
	},
	Decrement: {
		EN: 'Decrement',
		FR: 'Décrément',
		DE: 'Dekrement',
		IT: 'Decremento',
		ES: 'Disminución',
	},
	ErrorLoadingSpecs: {
		EN: 'Error fetching model specifications.',
		FR: 'Erreur lors de la récupération des spécifcations du modèle.',
		DE: 'Fehler beim Abrufen der Modellspezifikationen.',
		IT: 'Errore durante il recupero delle specifiche del modello.',
		ES: 'Error al obtener las especificaciones del modelo.',
	},
	HighPrice: {
		EN: 'High Price',
		FR: 'Prix élevé',
		DE: 'Hoher Preis',
		IT: 'Prezzo elevato',
		ES: 'Precio elevado',
	},
	Increment: {
		EN: 'Increment',
		FR: 'Incrément',
		DE: 'Inkrement',
		IT: 'Incremento',
		ES: 'Incremento',
	},
	InStoreOnly: {
		EN: 'This item is available in-store only. Please call for details on ordering.',
		FR: 'Cet article est disponible uniquement en magasin. Veuillez appeler pour plus de détails sur la commande.',
		DE: 'Dieser Artikel ist nur im Laden erhältlich. Bitte rufen Sie uns an, um weitere Informationen zur Bestellung zu erhalten.',
		IT: "Questo articolo è disponibile solo in negozio. Si prega di chiamare per ulteriori dettagli sull'ordinazione.",
		ES: 'Este artículo solo está disponible en tienda. Llame para obtener más información sobre cómo realizar un pedido.',
	},
	InvalidSelection: { 
		EN: "Invalid selection",
		DE: "Ungültige Auswahl",
		FR: "Sélection invalide",
		ES: "Selección inválida",
		IT: "Selezione non valida",
	},
	LowPrice: {
		EN: 'Low Price',
		FR: 'Prix bas',
		DE: 'Niedriger Preis',
		IT: 'Prezzo basso',
		ES: 'Precio bajo',
	},
	LowStock: { 
		EN: "Low Stock",
		DE: "Geringer Lagerbestand",
		FR: "Stock faible",
		ES: "Stock bajo",
		IT: "Scorte basse",
	},
	New: {
		EN: 'New',
		FR: 'Nouveau',
		DE: 'Neu',
		IT: 'Nuovo',
		ES: 'Nuevo',
	},
	NoBackorder: {
		EN: 'This item is back ordered and unavailable for purchase at this time.',
		FR: "Cet article est en rupture de stock et n'est pas disponible à la vente pour le moment.",
		DE: 'Dieser Artikel ist derzeit nicht vorrätig und kann derzeit nicht gekauft werden.',
		IT: "Questo articolo è in arretrato e non è disponibile per l'acquisto al momento.",
		ES: 'Este artículo está agotado y no está disponible para su compra en este momento.',
	},
	NoBackorderWithRestock: {
		EN: 'This item is currently back ordered and unavailable for purchase. It is expected to be restocked on [[REPLACE TEXT]].',
		FR: "Cet article est actuellement en rupture de stock et indisponible à l’achat. Il devrait être réapprovisionné le [[REPLACE TEXT]].",
		DE: 'Dieser Artikel ist derzeit im Rückstand und nicht zum Kauf verfügbar. Die Wiederverfügbarkeit wird am [[REPLACE TEXT]]. erwartet.',
		IT: "Questo articolo è attualmente in arretrato e non disponibile per l’acquisto. Si prevede che torni disponibile il [[REPLACE TEXT]].",
		ES: 'Este artículo se encuentra actualmente pendiente por falta de stock y no está disponible para su compra. Se espera que vuelva a estar disponible el [[REPLACE TEXT]].',
	},
	NotifyStock: {
		EN: 'Email me when this item is in stock',
		FR: 'Envoyez-moi un e-mail lorsque cet article sera en stock',
		DE: 'Benachrichtigen Sie mich per E-Mail, wenn dieser Artikel wieder vorrätig ist',
		IT: "Inviami un'e-mail quando questo articolo è disponibile",
		ES: 'Envíame un correo electrónico cuando este artículo esté disponible',
	},
	NotPurchasable: {
		EN: 'This item is not available for individual purchase. Please refer to the product overview for details on how to qualify for this promotion.',
		FR: "Cet article n'est pas disponible à l'achat individuel. Veuillez consulter la présentation du produit pour plus de détails sur les conditions d'éligibilité à cette promotion.",
		DE: 'Dieser Artikel ist nicht einzeln erhältlich. Weitere Informationen zur Teilnahmeberechtigung für diese Aktion finden Sie in der Produktübersicht.',
		IT: "Questo articolo non è disponibile per l'acquisto singolo. Per ulteriori dettagli su come beneficiare di questa promozione, consultare la panoramica del prodotto.",
		ES: 'Este artículo no está disponible para su compra individual. Consulte la descripción general del producto para obtener más información sobre cómo participar en esta promoción.',
	},
	NoWebOrdering: {
		EN: 'The item you have selected is not available for purchase online. See the Overview below for ordering instructions or',
		FR: "L'article que vous avez sélectionné n'est pas disponible à l'achat en ligne. Consultez l'aperçu ci-dessous pour obtenir des instructions sur la manière de passer commande ou",
		DE: 'Der von Ihnen ausgewählte Artikel ist nicht online erhältlich. Bestellhinweise finden Sie in der folgenden übersicht, oder',
		IT: "L'articolo selezionato non è disponibile per l'acquisto online. Per le istruzioni su come effettuare l'ordine, consultare la panoramica riportata di seguito oppure",
		ES: 'El artículo que ha seleccionado no está disponible para su compra en línea. Consulte la descripción general a continuación para obtener instrucciones sobre cómo realizar el pedido o',
	},
	OutOfStock: {
		EN: 'This item is out of stock',
		FR: 'Cet article est en rupture de stock',
		DE: 'Dieser Artikel ist nicht vorrätig',
		IT: 'Questo articolo è esaurito',
		ES: 'Este artículo está agotado',
	},
	OutOfStockShort: {
		EN: 'Out of stock',
		FR: 'Rupture de stock',
		DE: 'Nicht vorrätig',
		IT: 'Esaurito',
		ES: 'Agotado',
	},
	Popularity: {
		EN: 'Popularity',
		FR: 'Popularité',
		DE: 'Beliebtheit',
		IT: 'Popolarità',
		ES: 'Popularidad',
	},
	Preorder: {
		EN: 'This item is available for Pre-Order. It is expected to be available to ship on [[REPLACE TEXT]].',
		FR: 'Cet article est disponible en précommande. Il devrait être expédié le [[REPLACE TEXT]].',
		DE: 'Dieser Artikel kann vorbestellt werden. Der voraussichtliche Versandtermin ist der [[REPLACE TEXT]].',
		IT: 'Questo articolo è disponibile per il preordine. La spedizione è prevista per il [[REPLACE TEXT]].',
		ES: 'Este artículo está disponible para reserva. Se espera que esté disponible para su envío el [[REPLACE TEXT]].',
	},
	Prerelease: {
		EN: 'This item will be released on [[REPLACE TEXT]] and is not yet available.',
		FR: "Cet article sera commercialisé le [[REPLACE TEXT]] et n'est pas encore disponible.",
		DE: 'Dieser Artikel erscheint am [[REPLACE TEXT]] und ist noch nicht erhältlich.',
		IT: 'Questo articolo sarà disponibile dal [[REPLACE TEXT]] e non è ancora disponibile.',
		ES: 'Este artículo saldrá a la venta el [[REPLACE TEXT]] y aún no está disponible.',
	},
	Price: {
		EN: 'Price',
		FR: 'Prix',
		DE: 'Preis',
		IT: 'Prezzo',
		ES: 'Precio',
	},
	Quantity: {
		EN: 'Quantity',
		FR: 'Quantité',
		DE: 'Menge',
		IT: 'Quantità',
		ES: 'Cantidad',
	},
	QuantityAbbreviated: {
		EN: 'Qty',
		FR: 'Qté',
		DE: 'Menge',
		IT: 'Quantità',
		ES: 'Cantidad',
	},
	Relevance: {
		EN: 'Relevance',
		FR: 'Pertinence',
		DE: 'Relevanz',
		IT: 'Rilevanza',
		ES: 'Relevancia',
	},
	Sale: {
		EN: 'Sale',
		FR: 'Vente',
		DE: 'Verkauf',
		IT: 'Vendita',
		ES: 'Venta',
	},
	SelectSize: {
		EN: 'Select Size',
		FR: 'Sélectionner la taille',
		DE: 'Größe auswählen',
		IT: 'Seleziona la taglia',
		ES: 'Seleccionar tamaño',
	},
	Size: {
		EN: 'Size',
		FR: 'Taille',
		DE: 'Größe',
		IT: 'Dimensioni',
		ES: 'Tamaño',
	},
	Specifications: {
		EN: 'Specifications',
		FR: 'Spécifcations',
		DE: 'Spezifikationen',
		IT: 'Specifiche tecniche',
		ES: 'Especificaciones',
	},
	Unavailable: {
		EN: 'The selected item is unavailable.',
		FR: "L'article sélectionné n'est pas disponible.",
		DE: 'Der ausgewählte Artikel ist nicht verfügbar.',
		IT: "L'articolo selezionato non è disponibile.",
		ES: 'El artículo seleccionado no está disponible.',
	},
	UnavailableForPurchase: {
		EN: 'The selected item is unavailable for purchase at this time.',
		FR: "L'article sélectionné n'est pas disponible à l'achat pour le moment.",
		DE: 'Der ausgewählte Artikel ist derzeit nicht verfügbar.',
		IT: "L'articolo selezionato non è disponibile per l'acquisto in questo momento.",
		ES: 'El artículo seleccionado no está disponible para su compra en este momento.',
	},
	ZtoA: {
		EN: 'Z to A',
		FR: 'De Z à A',
		DE: 'Z bis A',
		IT: 'Da Z a A',
		ES: 'De la Z a la A',
	},
};

export function returnTranslatedStaticLabelsGivenLanguage(lang) {
	let translationPhraseObject = {};

	Object.keys(TranslationsObject).map((phrase) => {
		if (TranslationsObject[phrase][lang]) {
			translationPhraseObject[phrase] = decodeHtmlEntities(TranslationsObject[phrase][lang]);
		}
	});

	return translationPhraseObject;
}

export function replaceTextDelimeterWithText(phrase, text) {
	let replacedPhrase = phrase;

	if (typeof text !== 'undefined') {
		replacedPhrase = replacedPhrase.replaceAll(text_replace_delimeter, text);
	}

	return replacedPhrase;
}
